module.exports = __webpack_public_path__ + "static/media/popup-success.7dd24faf.svg";